export const SET_GAME_DETAIL = 'SET_GAME_DETAIL';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';

export const setGameDetail = (gameDetail) => ({
  type: SET_GAME_DETAIL,
  payload: gameDetail
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error
});

// 异步 action creator
export const fetchGameDetail = (id) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    // 这里模拟从 API 获取游戏详情数据
    const gameDetail = {
      id: parseInt(id),
      title: "Sample Game",
      description: "This is a sample game description.",
      gameUrl: "https://games.crazygames.com/en_US/squid-game-online/index.html?v=1.325",
      category: "action",
      players: "1 Player",
      platform: "HTML5",
      controls: {
        computer: [
          { key: "Mouse", action: "Click to interact" },
          { key: "Arrow Keys", action: "Movement" },
          { key: "Spacebar", action: "Jump/Action" }
        ],
        mobile: [
          { key: "Touch Screen", action: "Play" },
          { key: "Tap", action: "Interact" },
          { key: "Swipe", action: "Movement" }
        ]
      }
    };
    
    dispatch(setGameDetail(gameDetail));
  } catch (error) {
    dispatch(setError(error.message));
  } finally {
    dispatch(setLoading(false));
  }
}; 